import React from 'react';

const LoadingBar = ({ loading = false }) => (
  <div className={`news-infinite-scroll ${loading && 'loading'}`}>
    <div className="lds-css ng-scope">
      <div style={{ width: '100%', height: '100%' }} className="lds-rolling">
        <div></div>
      </div>
    </div>
    <div className="news-infinite-scroll__load-sensor"></div>
  </div>
);

export default LoadingBar;
